import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./index.css";
import "./analytics";
import App from "./App";
import { ResetPasswordPage } from "./ResetPasswordPage";
import { DeleteAccountPage } from "./DeleteAccountPage";

ReactDOM.render(
	<React.StrictMode>
		<BrowserRouter>
			<Routes>
				<Route path="/" element={<App />} />
				<Route path="newuser" element={<App showUserRamp={true} />} />
				<Route path="reset-password" element={<ResetPasswordPage />} />
				<Route path="delete-account" element={<DeleteAccountPage />} />
			</Routes>
		</BrowserRouter>
	</React.StrictMode>,
	document.getElementById("root")
);
